import React from 'react'
import SubServiceDetailSection2 from '../sections/SubServiceDetailSection2';
import SubServiceDetailSection1 from '../sections/SubServiceDetailSection1';
import ServicesShowcase from '../components/ServicesShowcase';
import BrandingExtraSection2 from '../sections/BrandingExtraSection2';
import { useServiceData } from '../context/ServiceDataContext';
import { Link, useLocation, useParams } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import Button from '../components/Button';
import SubServiceDetailNew1 from '../sections/SubServiceDetailNew1';
import SubServiceDetailNew2 from '../sections/SubServiceDetailNew2';


const SubServiceDetail = () => {

    const { getServiceById, getServiceByCategory } = useServiceData();
    const { pathname } = useLocation();
    const { id } = useParams();
    const service = getServiceById(`${pathname.split("/")[1]}`, id);
    const services = getServiceByCategory(`${pathname.split("/")[1]}`);

    console.log(service);

    return (
        <div className=''>
            <SubServiceDetailSection1 data={service.section1} lottieSrc={services.lottieSrc} />

            {
                service.id == 12 && pathname.split("/")[1] == "design" && (
                    <>
                        <SubServiceDetailNew1 />
                        <SubServiceDetailNew2 />
                    </>
                )
            }

            {
                service.section2.content.map((item, index) => (
                    <SubServiceDetailSection2 key={index} data={item} />
                ))
            }

            {
                service.section2.isBlog && (<div className='font-bold  bg-white dark:bg-zinc-800 dark:text-white xl:text-2xl flex justify-center xl:justify-start gap-2 pt-10 pb-30 xl:px-35 px-10 capitalize pointer-events-auto relative z-20 '>
                    To know more read our


                    <Link to={`/blogs`} className="text-left w-fit group pointer-events-auto cursor-pointer inline-block">
                        <h3 className="font-bold text-[#EE005B] flex items-center gap-2">
                            Our Blog
                            {/* <span className='inline-block -rotate-45 opacity-0 group-hover:opacity-100 duration-300'>< FiArrowRight /></span> */}
                        </h3>
                        <div className='w-full overflow-x-hidden'>
                            <div className="w-[200%] h-0.5 border-b-4 border-dotted border-gray-400 dark:border-gray-600 group-hover:-translate-x-[10%] duration-1000 group-hover:border-[#EE005B] "></div>
                        </div>
                    </Link>
                </div>)
            }

            <ServicesShowcase data={service.section3} superData={services} />
            {
                service.section4 &&
                <BrandingExtraSection2 data={service.section4} />
            }



            <section className="w-full relative z-20 py-24 md:py-32 bg-gradient-to-b from-[#DE1240] to-[#8A154F] flex flex-col items-center justify-center text-center">
                <h2 className="text-white text-3xl md:text-5xl font-bold mb-10 leading-tight mx-auto">
                    Let’s drive measurable results and meaningful <br className='hidden md:block' /> impact for your business.

                </h2>
                <Link to={"/contact"}>
                    <Button className={"text-white border-[#e4e4e7_!important]"}>
                        Let’s Get Started
                    </Button>
                </Link>
            </section>

        </div>
    )
}

export default SubServiceDetail